export default "__VITE_ASSET__CbRMuAIL__"